import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';

import { useRowsHeights } from './useRowsHeights';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  visibleRows?: number;
  maxVisibleRows?: number;
}

function ScrollableRows({
  children,
  visibleRows = 2,
  className,
  ...props
}: Props) {
  const { t } = useTranslation('settings');
  const containerRef = useRef<HTMLUListElement>(null);

  const { visibleRowsHeight, isOverflow } = useRowsHeights(
    containerRef,
    visibleRows,
  );

  return (
    <div
      data-testid="scrollable-container"
      className={cn({
        'rounded-xs px-md py-sm pr-0 outline outline-1 outline-offset-[-1px] bg-emphasis-default outline-emphasis-subtle':
          isOverflow,
        className,
      })}
      {...props}
    >
      <ul
        className={cn('flex flex-wrap gap-sm overflow-auto p-px pr-md')}
        ref={containerRef}
        style={{
          maxHeight: `${visibleRowsHeight}px`,
        }}
        aria-live="polite"
        aria-atomic="true"
        aria-label={t('selectedFilters')}
      >
        {children}
      </ul>
    </div>
  );
}

ScrollableRows.displayName = 'ScrollableRows';
export { ScrollableRows };
